import { cloneElement, ReactElement, ReactPortal, useState } from 'react'
import BigNumber from 'bignumber.js'
import styled from 'styled-components'
import { useTranslation } from 'contexts/Localization'
import { Flex, CardFooter, ExpandableLabel, HelpIcon, useTooltip, Tag, RefreshIcon } from '@pancakeswap/uikit'
import { DeserializedPool } from 'state/types'
import { CompoundingPoolTag, ManualPoolTag } from 'components/Tags'
import ExpandedFooter from './ExpandedFooter'

interface FooterProps {
  pool: DeserializedPool
  account: string
  totalCakeInVault?: BigNumber
  defaultExpanded?: boolean
}

const ExpandableButtonWrapper = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  button {
    padding: 0;
  }
`

const Footer: React.FC<FooterProps> = ({ pool, account, defaultExpanded }) => {
  const { vaultKey } = pool
  const { t } = useTranslation()
  const [isExpanded, setIsExpanded] = useState(defaultExpanded || false)

  const manualTooltipText = pool.isNft ? (
    pool.stakingToken.symbol === 'HH' ? (
      <div>
        <strong>Stake your HODL Hands® NFTs</strong>
        <br />
        <br />
        <p>
          Each NFT is valued at 0.20 BNB and earns tokens at the displayed APR. Rewards are calculated based on the
          $HODL price at the time of withdrawal.
        </p>
        <br />
        <p>Grow your rewards by joining the pool today!</p>
      </div>
    ) : (
      <div>
        <strong>Earn $HODL by staking your Gem Fighter NFTs</strong>
        <br />
        <br />
        <p style={{ paddingBottom: '1rem' }}>
          This pool is open to NFTs with IDs #{pool.allowedTokenIds?.from}-#{pool.allowedTokenIds?.to}. Check your NFT
          ID in your wallet, on this page, or in the HODL Telegram group.
        </p>
        <p style={{ paddingBottom: '1rem' }}>
          <strong>Pool Details</strong>
          <br />
          {pool.sousId === 53 ? (
            <>
              Eligible IDs: ${pool.allowedTokenIds?.from} to ${pool.allowedTokenIds?.to}
              <br />${pool.aprRange?.from}% APR
            </>
          ) : (
            <>
              NFT number 1,800 to 1,899: 200% APR
              <br />
              NFT number 1,900 to 2,149: 150% APR
              <br />
              NFT number 2,150 to 2,549: 100% APR
              <br />
            </>
          )}
        </p>
        <p>APR calculated on a fixed NFT value of $35</p>
        <br />
        <strong>Example</strong>
        <p>
          Stake 10 NFTs (total value $350) for 2 months at 250% APR → you’ll earn $145.83 worth of $HODL at withdrawal.
        </p>
      </div>
    )
  ) : (
    t('To claim your NFTs you must ‘Harvest’ and you can topup in BNB on any partially earned NFTs!', {
      symbol: pool.stakingToken.symbol,
    })
  )
  const autoTooltipText = t(
    'Any funds you stake in this pool will be automagically harvested and restaked (compounded) for you.',
  )

  const { targetRef, tooltip, tooltipVisible } = useTooltip(vaultKey ? autoTooltipText : manualTooltipText, {
    placement: 'bottom',
  })

  return (
    <CardFooter>
      <ExpandableButtonWrapper>
        <Flex alignItems="center" ref={targetRef}>
          {/* {vaultKey ? <CompoundingPoolTag /> : <ManualPoolTag />} */}
          {/* <Tag variant="secondary" outline startIcon={<RefreshIcon width="18px" color="secondary" mr="4px" />}>
            {t('How does it work?')}
          </Tag> */}
          <Tag variant="secondary" outline>
            {t('How it works')}
          </Tag>
          {/* {tooltipVisible &&
            cloneElement((tooltip as ReactPortal).children as ReactElement<any>, {
              style: { maxWidth: '340px', ...((tooltip as ReactPortal).children as ReactElement<any>).props.style },
            })} */}
          {tooltipVisible && tooltip}
          <Flex>
            <HelpIcon ml="4px" width="20px" height="20px" color="textSubtle" />
          </Flex>
        </Flex>
        <ExpandableLabel expanded={isExpanded} onClick={() => setIsExpanded(!isExpanded)}>
          {isExpanded ? t('Collapse') : t('Details')}
        </ExpandableLabel>
      </ExpandableButtonWrapper>
      {isExpanded && <ExpandedFooter pool={pool} account={account} />}
    </CardFooter>
  )
}

export default Footer
